const jsLoaderBg = '.loader-bg';
const jsDot = '.loader-dot-wrap > span';
const bunner = '.utility-bar';
const header = '.header-wrapper';
const mainContent = '#MainContent';

const time = new Date(new Date().getTime());
// アニメーションとクッキー保存のロジックを関数に抽出
function showAnimationAndSetCookie() {
  gsap.set(jsLoaderBg, {
    autoAlpha: 1,
  });

  gsap.set([bunner, header, mainContent], {
    autoAlpha: 0,
  });

  gsap.set(jsDot, {
    autoAlpha: 0,
    scale: 0,
    transformOrigin: 'center bottom',
  });

  const tl = gsap.timeline();
  tl.to(jsDot, {
    autoAlpha: 1,
    scale: 1,
    duration: 2,
    ease: 'elastic.out(1,0.3)',
    delay: 1,
    stagger: {
      amount: 1, //0.5秒おきに
      from: 'start', // 左から
    },
  })
    .to(
      jsLoaderBg,
      {
        autoAlpha: 0,
        duration: 0.8,
      },
      '-=0.5'
    )
    .to(
      [bunner, header, mainContent],
      {
        autoAlpha: 1,
        duration: 1.2,
      },
      '-=0.8'
    );

  Cookies.set('splash-container', time, {
    path: '/',
  });
}

// クッキーが存在しない場合、または24時間以上経過している場合にアニメーションを表示
const splashContainerValue = Cookies.get('splash-container');
if (!splashContainerValue || time - new Date(splashContainerValue) >= 3600000) {
  showAnimationAndSetCookie();
} else {
}
